<fieldset class="grid" aria-label="Einstellungen zu LFPR Blattabschrift" data-test-id="aufgabe-versand-root">
	<div class="column">
		<fieldset
			[ngClass]="formGroup.invalid ? 'error' : 'noerror'"
			class="column empfaenger"
			aria-label="Empfänger auswählen">
			<legend>{{ formGroup.valid ? 'Empfänger' : 'Empfänger *' }}</legend>
			<div>
				<mat-form-field appearance="outline" class="narrow">
					<mat-label>Anzahl</mat-label>
					<input
						min="0"
						matInput
						type="number"
						[formControl]="bodyControls.einfacheAn"
						data-test-id="einfache-input" />
				</mat-form-field>
				einfache an:
			</div>
			@if (bodyControls.einfacheAn.value > 0) {
				<fieldset class="inline-group" data-test-id="abschrift-einfach-fieldset">
					<mat-checkbox
						[formControl]="einfacheControls.glaeubigerNeu"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-einfach-checkbox-glaeubiger-neu">
						Gläubiger neu II/
					</mat-checkbox>
					<schir-int-client-one-value-editor
						type="text"
						label="Nr. in Abt. II"
						[fieldControl]="einfacheControls.glaeubigerNeuNr"
						data-test-id="abschrift-einfach-input-glaeubiger-neu" />
					<br />
					<mat-checkbox
						[formControl]="einfacheControls.glaeubigerAlt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-einfach-checkbox-glaeubiger-alt">
						Gläubiger alt II/
					</mat-checkbox>
					<schir-int-client-one-value-editor
						type="text"
						label="Nr. in Abt. II"
						[fieldControl]="einfacheControls.glaeubigerAltNr"
						data-test-id="abschrift-einfach-input-glaeubiger-alt" />
					<br />
					<mat-checkbox
						[formControl]="einfacheControls.notar"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-einfach-checkbox-notar">
						Notar
					</mat-checkbox>
					<mat-checkbox
						[formControl]="einfacheControls.eigentuemerNeu"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-einfach-checkbox-eigentuemer-neu">
						Eigentümer neu
					</mat-checkbox>
					<mat-checkbox
						[formControl]="einfacheControls.eigentuemerAlt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-einfach-checkbox-eigentuemer-alt">
						Eigentümer alt
					</mat-checkbox>
					<mat-checkbox
						[formControl]="einfacheControls.rechtsanwalt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-einfach-checkbox-rechtsanwalt">
						Rechtsanwalt
					</mat-checkbox>
				</fieldset>
			}

			<div>
				<mat-form-field appearance="outline" class="narrow">
					<mat-label>Anzahl</mat-label>
					<input
						min="0"
						matInput
						type="number"
						[formControl]="bodyControls.beglaubigteAn"
						data-test-id="beglaubigte-input" />
				</mat-form-field>
				beglaubigte an:
			</div>
			@if (bodyControls.beglaubigteAn.value > 0) {
				<fieldset class="inline-group" data-test-id="abschrift-beglaubigt-fieldset">
					<mat-checkbox
						[formControl]="beglaubigteControls.glaeubigerNeu"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-beglaubigt-checkbox-glaeubiger-neu">
						Gläubiger neu II/
					</mat-checkbox>
					<schir-int-client-one-value-editor
						type="text"
						label="Nr. in Abt. II"
						[fieldControl]="beglaubigteControls.glaeubigerNeuNr"
						data-test-id="abschrift-beglaubigt-input-glaeubiger" />
					<br />
					<mat-checkbox
						[formControl]="beglaubigteControls.glaeubigerAlt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-beglaubigt-checkbox-glaeubiger-alt">
						Gläubiger alt II/
					</mat-checkbox>
					<schir-int-client-one-value-editor
						type="text"
						label="Nr. in Abt. II"
						[fieldControl]="beglaubigteControls.glaeubigerAltNr"
						data-test-id="abschrift-beglaubigt-input-glaeubiger-alt" />
					<br />
					<mat-checkbox
						[formControl]="beglaubigteControls.notar"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-beglaubigt-checkbox-notar">
						Notar
					</mat-checkbox>
					<mat-checkbox
						[formControl]="beglaubigteControls.eigentuemerNeu"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-beglaubigt-checkbox-eigentuemer-neu">
						Eigentümer neu
					</mat-checkbox>
					<mat-checkbox
						[formControl]="beglaubigteControls.eigentuemerAlt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-beglaubigt-checkbox-eigentuemer-alt">
						Eigentümer alt
					</mat-checkbox>
					<mat-checkbox
						[formControl]="beglaubigteControls.rechtsanwalt"
						color="primary"
						class="focus-inwards-dark"
						data-test-id="abschrift-beglaubigt-checkbox-rechtsanwalt">
						Rechtsanwalt
					</mat-checkbox>
				</fieldset>
			}
		</fieldset>
		@if (formGroup.invalid) {
			<mat-error data-test-id="invalid-checkbox-message">Bitte Empfänger wählen</mat-error>
		}
	</div>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.LFPR_BLATTABSCHRIFT" />
</fieldset>
